// 23 彩种 + 所属族(据 子模块详解.md)。family 决定开奖结果列与赔率玩法。
export const GAMES = [
  { code: 'jssc', name: '极速赛车', family: 'race' },
  { code: 'azxy10', name: '澳洲幸运10', family: 'race' },
  { code: 'azxy5', name: '澳洲幸运5', family: 'ssc' },
  { code: 'xyft', name: '幸运飞艇', family: 'race' },
  { code: 'jsft', name: '极速飞艇', family: 'race' },
  { code: 'jsssc', name: '极速时时彩', family: 'ssc' },
  { code: 'sgft', name: 'SG飞艇', family: 'race' },
  { code: 'xyssc', name: '幸运时时彩', family: 'ssc' },
  { code: 'pcdd', name: 'PC蛋蛋', family: 'pc28' },
  { code: 'jsk3', name: '极速快3', family: 'k3' },
  { code: 'jnd28_1', name: '加拿大28-玩法一', family: 'pc28' },
  { code: 'jnd28_2', name: '加拿大28-玩法二', family: 'pc28' },
  { code: 'jnd28_3', name: '加拿大28-玩法三', family: 'pc28' },
  { code: 'dwydh', name: '动物运动会', family: 'sport' },
  { code: 'wfydh', name: '五分运动会', family: 'sport' },
  { code: 'fc3d', name: '福彩3D', family: 'p3d' },
  { code: 'tcpl3', name: '体彩排列3', family: 'p3d' },
  { code: 'amlhc', name: '澳门六合彩', family: 'lhc' },
  { code: 'xamlhc', name: '新澳门六合彩', family: 'lhc' },
  { code: 'bgssc1', name: '宾果时时彩(一)', family: 'ssc' },
  { code: 'bgsc', name: '宾果赛车(A)', family: 'race' },
  { code: 'bglhc', name: '宾果六合彩', family: 'lhc' },
  { code: 'hk6', name: '香港六合彩', family: 'lhc' }
]

// 开奖结果列(按族;据 子模块详解.md §6)
export const OPEN_COLUMNS = {
  pc28: ['期号', '开奖时间', '开奖结果', '总和', '大小', '单双', '极值', '色波'],
  ssc: ['期号', '开奖时间', '开奖结果', '总和', '龙虎', '前三', '中三', '後三'],
  race: ['期号', '开奖时间', '开奖结果', '冠亚军和', '1~5龙虎'],
  sport: ['期号', '开奖时间', '开奖结果', '1~3龙虎'],
  k3: ['期号', '开奖时间', '开奖结果', '总和'],
  p3d: ['期数', '开奖时间', '佰位', '拾位', '个位', '佰拾个和数', '跨度', '佰大小', '佰单双', '佰质合', '拾大小', '拾单双', '拾质合', '个大小', '个单双', '个质合'],
  // 六合彩开奖行(据 orig-open-49 名爵原站 DOM):2 行分组表头,18 个叶子列。
  // 顶行「总和」colspan=4 罩 {总数,单双,大小,七色波};「特码」colspan=5 罩 {单双,大小,合单双,合大小,大小尾}。
  // 正码一~六 + 特码 为号码球列;其余为大小/单双/波色 token 列。表头分组在 Open.vue 内定义。
  lhc: ['期数', '开奖时间', '正码一', '正码二', '正码三', '正码四', '正码五', '正码六', '特码', '总数', '单双', '大小', '七色波', '单双', '大小', '合单双', '合大小', '大小尾']
}

// 赔率玩法分组(按族;据 子模块详解.md §9)
export const QUOTA_GROUPS = {
  ssc: ['两面', '1-5球号', '龙虎和', '前三后三中三'],
  race: ['1-10车号', '两面', '冠亚军和大小', '冠亚军和单双', '冠亚军和'],
  pc28: ['和值', '大小', '单双', '大小单双', '极值大小', '豹子', '对子', '顺子', '色波', '特码包三', '1-3球号', '龙虎和', '定位两面'],
  k3: ['大小', '单骰', '豹子', '全骰', '总和', '对子', '单双'],
  p3d: ['两面', '一字定位', '二字定位', '三字定位', '一字组合', '二字组合', '三字组合', '二字和数', '三字和数', '组选三', '组选六', '跨度', '和数尾'],
  sport: ['1-6车号', '两面'],
  // 六合彩顶层玩法分类(据 orig-quo-39 名爵原站 DOM 顶部 Tab 顺序);每类下含二级玩法子 Tab(见 Quota.vue LHC_SUBTABS)
  lhc: ['特码', '正码', '正特码', '色波', '一肖尾数', '连肖', '连尾', '连码', '其他']
}

// 赔率表固定 6 列
export const QUOTA_COLUMNS = ['玩法', '赔率', '个人单注最低限额', '个人单注最高限额', '个人单期最高限额', '单期总限额']
